import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import VesselTypeList from '~/containers/vesselTypeList/vesselTypeList';

export default class VesselTypesPage extends Component {
  render() {
    const createButton = (
      <Link to="/settings/vesseltypes/create">
        <Button color="primary">New vessel type</Button>
      </Link>
    );
    return (
      <Page>
        <TitleBar back="/settings" backText="Settings" title="Vessel Types" button={createButton} />
        <VesselTypeList />
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/vesselTypes/vesselTypes.jsx